import React from 'react';
import PropTypes from 'prop-types';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

//Para los select
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import Select2 from 'react-select';
import InputLabel from '@material-ui/core/InputLabel';

import purple from '@material-ui/core/colors/purple';
import Switch from '@material-ui/core/Switch';
import { withStyles } from '@material-ui/core/styles';
import {
  COST_TYPE_LABOR,
  COST_TYPE_EQUIPMENT, 
  COST_TYPE_MATERIAL,
  COST_TYPE_OTHER,
  COST_TYPE_SUBCONTRACT,} from '../common/redux/constantes';

const styles = theme => ({
  colorSwitchBase: {
    color: purple[300],
    '&$colorChecked': {
      color: purple[500],
      '& + $colorBar': {
        backgroundColor: purple[500],
      },
    },
  },
  colorBar: {},
  colorChecked: {},
  iOSSwitchBase: {
    '&$iOSChecked': {
      color: theme.palette.common.white,
      '& + $iOSBar': {
        backgroundColor: '#52d869',
      },
    },
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
      easing: theme.transitions.easing.sharp,
    }),
  },
  iOSChecked: {
    transform: 'translateX(15px)',
    '& + $iOSBar': {
      opacity: 1,
      border: 'none',
    },
  },
  iOSBar: {
    borderRadius: 13,
    width: 42,
    height: 26,
    marginTop: -13,
    marginLeft: -21,
    border: 'solid 1px',
    borderColor: theme.palette.grey[400],
    backgroundColor: theme.palette.grey[50],
    opacity: 1,
    transition: theme.transitions.create(['background-color', 'border']),
  },
  iOSIcon: {
    width: 24,
    height: 24,
  },
  iOSIconChecked: {
    boxShadow: theme.shadows[1],
  },
});

class  GeneralCostInfo extends React.Component  {

  state = {
    checkedB: false,
  };

  constructor(props)
  {
    super(props);
    //Bindings
    this.handleChangeSelect=this.handleChangeSelect.bind(this);
  }


  handleChange = name => event => 
  {
    this.setState({ [name]: event.target.checked });
    if(!this.state.checkedB)
    {
      this.props.handleChange({target:{value:null,id:'cost_catalog'}}) 
    }
  };
  
  handleChangeSelect(val){
   this.props.handleChange({target:{value:val.value,id:'cost_catalog'}}) 
  }


  getValueCatalog(opts, id) 
  {
    let realValue = {};
    if(opts)
    {
      realValue = opts.find(o => o.value === id);
    }
    return realValue;
  }



  render()
  {
    const { classes } = this.props;
    return (

      <React.Fragment>
        <Typography variant="h6" gutterBottom>
          Cost Information
        </Typography>
        <Grid container spacing={24}>
        
          { !this.props.reviewActive?
            (

            <Grid item xs={12} sm={6} >

            <div style={{marginTop:'5px'}}>
            <InputLabel htmlFor="check_cost_catalog" style={{marginRight:'10px'}}>Select/Create</InputLabel>
              <Switch
                fullWidth
                classes={{
                  switchBase: classes.iOSSwitchBase,
                  bar: classes.iOSBar,
                  icon: classes.iOSIcon,
                  iconChecked: classes.iOSIconChecked,
                  checked: classes.iOSChecked,
                }}
                disableRipple
                checked={this.state.checkedB}
                onChange={this.handleChange('checkedB')}
                value="checkedB"
              />

            </div>
            </Grid>
            ):null}
         <Grid item xs={12} sm={6}>
            
            {this.state.checkedB || this.props.reviewActive?(
            <TextField
              required
              id="description"
              name="description"
              label="Resource"
              fullWidth
              autoComplete="description"
              value={this.props.costinfo.description}
              onChange={this.props.handleChange}
              disabled={this.props.reviewActive}
              error={this.props.errores.description}
              helperText={this.props.errores.description}
            />
            ):(
            <div>
              <InputLabel htmlFor="cost_catalog" style={{marginRight:'10px'}}>Resource</InputLabel>
              <Select2
                fullWidth
                required
                id="cost_catalog"
                name="cost_catalog"
                options={this.props.cost_catalogs}
                onChange={this.handleChangeSelect}
                value={this.getValueCatalog(this.props.cost_catalogs,this.props.costinfo.cost_catalog)}
                isDisabled={this.props.reviewActive}
                error={this.props.errores.cost_catalog}
                errorText={this.props.errores.cost_catalog}
                helperText={this.props.errores.cost_catalog}
                styles={{control: (provided,state) => (this.props.errores.cost_catalog ? {...provided,borderColor: 'red', } : provided)}}
              >
              </Select2>
            </div>
            )}
          </Grid>

          <Grid item xs={12} sm={6}>
            <div style={{marginTop:'5%'}}>
              <InputLabel htmlFor="type" style={{marginRight:'10px'}}>Type</InputLabel>
              <Select
                required
                id="type"
                name="type"
                value={this.props.costinfo.type}
                onChange={this.props.handleChange}
                disabled={this.props.reviewActive}
                error={this.props.errores.type}
                helperText={this.props.errores.type}
              >
                <MenuItem native="true" key={COST_TYPE_LABOR} value={COST_TYPE_LABOR} selected>
                  Labor
                </MenuItem>
                <MenuItem native="true" key={COST_TYPE_EQUIPMENT} value={COST_TYPE_EQUIPMENT}>
                  Equipment
                </MenuItem>
                <MenuItem native="true" key={COST_TYPE_MATERIAL} value={COST_TYPE_MATERIAL}>
                  Material
                </MenuItem>
                <MenuItem native="true" key={COST_TYPE_SUBCONTRACT} value={COST_TYPE_SUBCONTRACT}>
                  Subcontract
                </MenuItem>
                <MenuItem native="true" key={COST_TYPE_OTHER} value={COST_TYPE_OTHER}>
                  Other
                </MenuItem>
              </Select>
            </div>
          </Grid>
          </Grid>
        </React.Fragment>
    );
  }
}

GeneralCostInfo.propTypes = {
  classes: PropTypes.object.isRequired,
};




export default withStyles(styles)(GeneralCostInfo);


// WEBPACK FOOTER //
// ./src/features/cost/GeneralCostInfo.js